import { render, staticRenderFns } from "./simple-sso.vue?vue&type=template&id=1a1d8d59&scoped=true&"
import script from "./simple-sso.vue?vue&type=script&lang=js&"
export * from "./simple-sso.vue?vue&type=script&lang=js&"
import style0 from "./simple-sso.vue?vue&type=style&index=0&id=1a1d8d59&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.7_eeqz4xtr3chsfpwu4zsrvzqhvy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1d8d59",
  null
  
)

export default component.exports